import React from 'react'

export const newMexicoSetupVars = {
  siteId: 'new_mexico',
  pathPrefix: '/nm',
  menuHeader: "Discover New Mexico's Solution for:",
  appUrl: 'https://nm.headed2.com',
  logoImg: '/images/assets/new_mexico/horizontal/dark.svg',
  headerTitle: `The New Mexico CareerExplorer is a system designed for New Mexico`
}
